/** @format */

import React, { useRef } from 'react'
import { _$, FormItem, Form, Input, Button, Message } from '@king-design/react'
import styled from 'styled-components'
import { useParams, useHistory } from 'react-router'
import { IMonitorGraphData, graphType } from './constants'
import EditGraphMetricForm from './EditGraphMetricForm'
import { request, handleParamsCase } from 'src/utils'
import API from 'src/api/ApiDashboard'
import { cloneDeep } from 'lodash'
import variable from 'src/static/styles/var'

interface EditGraphFormProps {
  className?: string
  formValue: IMonitorGraphData
  handleChangeForm: (value: any) => void
  handleChangeMetrics: (value: any) => void
}
const EditGraphForm: React.FC<EditGraphFormProps> = ({
  className,
  formValue,
  handleChangeForm,
  handleChangeMetrics
}) => {
  const { graphID, dashboardId } =
    useParams<{ dashboardId: string; dashboardName: string; graphID: string }>()
  // const [discoveryMetricFlag, setDiscoveryMetricFlag] = useState<boolean>()
  const history = useHistory()
  const formRef = useRef<any>()
  const metricRef = useRef<any>()

  // 提交
  const handeSubmit = async e => {
    const valid = await formRef.current.validate()
    const metricValid = await metricRef.current.validate()
    const lineCountValid = handleLineCount()
    if (valid && metricValid && lineCountValid) {
      const copyValues = cloneDeep(formValue)
      copyValues.metrics.forEach((metric, index) => {
        const mapId = metric.instances?.map(({ instanceId }) => instanceId)
        metric.instances = mapId
        metric.displayOrder = index + 1
        // 临时处理老数据实例组的问题
        metric.InstanceGroups = []
        metric.ResourceBindType = 0
      })
      const params = handleParamsCase(copyValues)
      const result = await request(API.PutDashboardGraph, {
        method: 'POST',
        data: params
      })
      if (result.code === 'Success') {
        Message.success(graphID === 'create' ? _$('新建成功') : _$('编辑成功'))
        handleBack()
      }
    }
  }

  // 返回
  const handleBack = () => {
    history.push(`/monitor/dashboard/detail/private/${dashboardId}`)
  }

  // 计算总条数
  const handleLineCount = () => {
    const countList = []
    const repeatList = []
    formValue.metrics.forEach(({ productType, metricKey, instances, resourceAggregator }) => {
      instances.forEach(({ instanceId }) => {
        const key = `${productType}-${metricKey}-${instanceId}-${resourceAggregator}`
        if (countList.includes(key)) {
          repeatList.push(key)
        } else {
          countList.push(key)
        }
      })
    })
    if (countList.length > 1000) {
      Message.error(_$('单个视图最多可新建1000条监控数据'))
      return false
    } else {
      return true
    }
  }

  return (
    <div className={className}>
      {formValue ? (
        <>
          <Form starOnRequired ref={formRef} labelWidth={120}>
            <FormItem
              label={_$('视图名称')}
              value={formValue?.title}
              rules={{ required: true, userName: true }}
              messages={{
                required: _$('请输入视图名称')
              }}
            >
              <Input
                value={formValue?.title}
                placeholder={_$('请输入视图名称')}
                onChangeValue={value => handleChangeForm({ title: value })}
              ></Input>
            </FormItem>
            <FormItem
              className="graph-type"
              label={_$('图表类型')}
              value={formValue?.graphType || 'line'}
              rules={{ required: true }}
              messages={{
                required: _$('请选择图表类型')
              }}
            >
              <div className="graph-type-list">
                {graphType.map(({ title, value }) => {
                  const active = formValue?.graphType || 'line' === value ? 'active' : ''
                  return (
                    <div
                      key={value}
                      className={`graph-type-icon graph-type-${value} ${active}`}
                      onClick={() => {
                        handleChangeForm({ graphType: value })
                      }}
                    >
                      <p>{_$(title)}</p>
                    </div>
                  )
                })}
              </div>
            </FormItem>
          </Form>
          <p className="tips">*{_$('单个视图最多可新建1000条监控数据')}</p>
          <EditGraphMetricForm
            form={metricRef}
            metricList={formValue?.metrics}
            handleChangeMetrics={handleChangeMetrics}
            handleLineCount={handleLineCount}
          />
          <div className="btn-group">
            <Button type="primary" onClick={handeSubmit}>
              {_$('提交')}
            </Button>
            <Button onClick={handleBack}>{_$('返回')}</Button>
          </div>
        </>
      ) : null}
    </div>
  )
}

export default styled(EditGraphForm)`
  margin-top: 32px;
  .graph-type {
    .k-label {
      vertical-align: middle;
    }
    .graph-type-list {
      display: flex;
      align-items: center;
      .graph-type-icon {
        width: 60px;
        height: 70px;
        border: 1px solid transparent;
        cursor: pointer;
        background-size: 40px;
        background-repeat: no-repeat;
        background-position: 10px 5px;
        margin-right: 8px;
        p {
          padding-top: 45px;
          line-height: 20px;
          text-align: center;
          color: #666;
        }
        &.active {
          border: 1px solid ${variable.primaryColor};
        }
      }
    }
  }
  .tips {
    margin-top: 16px;
    margin-left: 100px;
    color: #999;
  }
  .btn-group {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
    padding-top: 16px;
    border-top: 1px solid #e5e5e5;
    & > * {
      margin: 0 8px;
    }
  }
`
